export default "__VITE_ASSET__DWFpRgJN__"